export default __webpack_public_path__ + "static/media/qszx.0e0175ea.jpg";